var wamClient = require('./build/wam/WAMClient');

module.exports = wamClient;